import { get, post } from "./http";

export const apiGetBanner = (p) => get("/api/siteInfo/banner/list", p); //首页轮播图
export const submitForm = (p) => post("/server/v1/console/base/data/leave_message/save", p); //自助报修
export const querySubmit = (p) => post("/scheduling/common/data/selleavebytel", p); //查询已提交信息